import { COMPANY_SELECTED } from './actionTypes';

export const setReduxCompanySelected = (data) => {
  return {
    type: COMPANY_SELECTED,
    data,
  };
};
